import { createContext } from 'react'

import { CustomFormAnswer } from 'components/tools/CustomForm/types'
import { ValidationAnswerRoute } from '../..'

export type CustomFormAnswerManagerType = {
  answer: CustomFormAnswer
  validationAnswer?: ValidationAnswerRoute
}

const defaultValues = {
  answer: {},
}

const CustomFormAnswerManagerContext = createContext<CustomFormAnswerManagerType>(defaultValues)

export default CustomFormAnswerManagerContext
